// Shared UI primitive (reused across all dashboard pages) — MIS-809.
//
// A native <select> wrapper (deliberately NOT Radix — keeps the bundle
// dependency-free). Pass <option> children. Styled to match Input.

import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-[var(--border-soft)] bg-[var(--surface-2)] px-3 py-1 text-sm text-[var(--text)]',
        'focus-visible:border-[var(--accent)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
